import Confetti from 'react-dom-confetti';
import {Box} from '@mui/material';

const confettiConfig = {
  angle: 90,
  spread: 75,
  startVelocity: 35,
  elementCount: 130,
  dragFriction: 0.1,
  duration: 2070,
  stagger: 1,
  width: '7px',
  height: '5px',
  perspective: '1000px',
  colors: ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a'],
};

type ConfettiContainerProps = {
  active: boolean;
  numPops?: number;
  onDismiss?: () => void;
};

export const ConfettiContainer = ({
  active,
  numPops = 3,
  onDismiss,
}: ConfettiContainerProps) => {
  return (
    <Box
      onClick={onDismiss}
      data-attr={onDismiss ? 'confetti-container-dismiss' : undefined}
      sx={{
        position: 'fixed',
        gridTemplateColumns: '1fr 1fr 1fr',
        gridTemplateRows: '1fr 1fr 1fr',
        width: '100%',
        height: '100%',
        zIndex: 100000,
        display: active ? 'grid' : 'none',
        bottom: 0,
      }}
    >
      {Array.from(Array(3).keys()).map(int => (
        <Box
          key={'confetti-' + int}
          sx={{
            gridRow: 3,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          gridColumn={int + 1}
        >
          <Confetti
            active={active && (numPops === 3 || int === 1)}
            config={confettiConfig}
          />
        </Box>
      ))}
    </Box>
  );
};
